module.exports = __webpack_public_path__ + "static/media/connect-linear-lg-dark.3aaa8ee4.svg";